module.exports = ".taginput {\r\n  background-color: #fff;\r\n  background-image: none;\r\n  border: 1px solid #ccc;\r\n  border-radius: 4px;\r\n  padding-left: 5px;\r\n}\r\n\r\n.button-col {\r\n  width: 100px;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/brokers/components/scripts/broker.css
// module id = ./src/app/brokers/components/scripts/broker.css
// module chunks = main